import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { QuotationComponent } from './quotation/quotation.component'
import { ReceiptComponent } from './receipt/receipt.component'
import { BillingNoteInvoiceComponent } from './billing-note-invoice/billing-note-invoice.component'
import { TaxInvoiceComponent } from './tax-invoice/tax-invoice.component'
import { ShopeeLazadaComponent } from './shopee-lazada/shopee-lazada.component'
import { MobilePosComponent } from './mobile-pos/mobile-pos.component'
import { FlowpayComponent } from './flowpay/flowpay.component'
import { TaxCalculationComponent } from './tax-calculation/tax-calculation.component'
import { FunctionsForBusinessComponent } from './functions-for-business/functions-for-business.component'
import { FunctionsForAccountingComponent } from './functions-for-accounting/functions-for-accounting.component'

const routes: Routes = [
  {
    path: '',
    redirectTo: 'business',
    pathMatch: 'full',
  },
  {
    path: 'business',
    component: FunctionsForBusinessComponent,
  },
  {
    path: 'accounting',
    component: FunctionsForAccountingComponent,
  },
  {
    path: 'quotation',
    component: QuotationComponent,
  },
  {
    path: 'receipt',
    component: ReceiptComponent,
  },
  {
    path: 'invoice',
    component: BillingNoteInvoiceComponent,
  },
  {
    path: 'tax-invoice',
    component: TaxInvoiceComponent,
  },
  {
    path: 'shopee-lazada',
    component: ShopeeLazadaComponent,
  },
  {
    path: 'e-commerce',
    component: ShopeeLazadaComponent,
  },
  {
    path: 'mobile-pos',
    component: MobilePosComponent,
  },
  {
    path: 'flowpay',
    component: FlowpayComponent,
  },
  {
    path: 'calculator-tax-and-profit',
    component: TaxCalculationComponent,
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FunctionsRoutingModule {}
